// extracted by mini-css-extract-plugin
module.exports = {"heading":"ModalDowngradeSubscription_heading__22_q3","content":"ModalDowngradeSubscription_content__13Gu2"};